export default __webpack_public_path__ + "images/1eeb767a6d9e4410588bb3dbe7196e24-walking_small.webp";